import {useEffect} from 'react';
import {started} from './successfulStart';

export function useStartupEvents(): void {
  useEffect(() => {
    started();
  });
}
